module.exports = __webpack_public_path__ + "img/classic_m4.67a69b93.png";